export const site = {
  name: "WeLivdIt",
  tagline: "Visa Interview Coaching",
  description:
    "WeLivdIt helps students prepare for US visa interviews with mock sessions, DS-160 guidance, and a 264-strong success community.",
  whatsapp: "https://wa.me/916300736712?text=Hi%20WeLivdIt%20team%2C%20I%27d%20love%20to%20chat%20about%20my%20US%20visa%20prep.",
  whatsappNumber: "+91 63007 36712",
  phone: "+91 63007 36712",
  phoneTel: "+916300736712",
  email: "hello@welivdit.com",
  legalName: "WeLivdIt Private Limited",
  cin: "U74999TG2021PTC149756",
  address: {
    line1: "Plot No. 57, Phase 2, JPN Nagar",
    line2: "Miyapur, Hyderabad, Rangareddi",
    region: "Telangana, India - 500049",
    full: "Plot No. 57, Phase 2, JPN Nagar, Miyapur, Hyderabad, Rangareddi, Telangana, India - 500049",
  },
  socials: {
    instagram: "https://www.instagram.com/welivdit/",
    linkedin: "https://in.linkedin.com/company/welivdit",
    trustpilot: "https://www.trustpilot.com/review/welivdit.com",
  },
  rating: { score: 4.7, count: 264 },
  // Razorpay payment links - replace each with the live link from your Razorpay dashboard.
  // Keys MUST match the PlanKey values: "basic" | "full" | "refusal".
  razorpay: {
    basic: "https://razorpay.com/payment-link/REPLACE_WITH_BASIC_LINK",
    full: "https://razorpay.com/payment-link/REPLACE_WITH_FULL_LINK",
    refusal: "https://razorpay.com/payment-link/REPLACE_WITH_REFUSAL_LINK",
  },
};
